import { createReducer } from '../../utils';
import types from './types';

export const initialState = {
    btns: {}
};

const ACTION_HANDLERS = {
    [types.SF_CHANGE_BTN_STATE]: (state, action) => ({
        ...state,
        btns: {
            ...state.btns,
            [action.btnId]: action.online
        }
    })
};

export default createReducer(ACTION_HANDLERS, initialState);
